import { getDays, getHours, getMinutes, getSeconds, hasDays } from '@core/shared';
import { useAppSelector } from '@online-webinar/store';
import { useTranslation } from 'react-i18next';
import { LabelHeading } from '../LabelHeading';

export const StartInTime = () => {
    const { t } = useTranslation();
    const remainingTimeToStart = useAppSelector((state) => state.liveWebinar.remainingTimeToStart);
    if (!remainingTimeToStart) {
        return null;
    }

    const title = t(remainingTimeToStart > 0 ? 'Broadcaster.Status.GoLiveIn' : 'Broadcaster.Status.GoLiveNow');

    return (
        <div className="flex flex-col justify-center px-2 md:px-5">
            <LabelHeading name={title} />
            {remainingTimeToStart > 0 && (
                <div className="font-medium font-accent text-xl min-w-[7.8rem] leading-tight">
                    <div className="countdown-time">
                        {hasDays(remainingTimeToStart) && <span>{getDays(remainingTimeToStart)}&nbsp;</span>}
                        <span>{getHours(remainingTimeToStart)}</span>:<span>{getMinutes(remainingTimeToStart)}</span>:
                        <span>{getSeconds(remainingTimeToStart)}</span>
                    </div>
                </div>
            )}
        </div>
    );
};
